<template>
    <div :class="{ 'pb24': isMobile }">
        <div class="d-flex justify-content-between align-items-center" :class="{ 'mb16': !isMobile, 'mb32': isMobile }">
            <div v-if="isMobile">
                <Icon name="arrow-left" class="c24 pointer" @click="this.close()"/>
            </div>
            <div class="flex-grow-1 fsp20 lh28" :class="{ 'text-center mr24': isMobile }">
                <h4 class="mb-0 fsp20 lh28 neue">{{ this.$t('components.service.modal.p2p.AdInfo.1') }} #{{ this.data.code }}</h4>
            </div>
            <div v-if="!isMobile">
                <Icon name="close" class="c24 pointer" @click="this.close()"/>
            </div>
        </div>
        <div class="bg-white rounded12 fsp14" :class="{ 'p24': !isMobile }">
            <div class="neue-roman pb24 mb24 border-b lh20">
                <div class="mb16">
                    <label class="mb8">{{ $t('views.P2P.Edit.2') }}</label>
                    <InputSimple
                        type='textarea'
                        :dataValue='this.data.external_note'
                        :label="$t('views.P2P.Edit.2')"
                        id='external_note' 
                        rows="4"
                        @updateParentState="this.setValue"
                    />
                </div>
                <div>
                    <label class="mb8">{{ $t('views.P2P.New.47') }}</label>
                    <InputSimple 
                        type='textarea'
                        :dataValue='this.data.external_requisites'
                        :label="$t('views.P2P.Edit.3')"
                        id='external_requisites'
                        rows="4"
                        @updateParentState="this.setValue"
                    />
                </div>
            </div>
            <div class="mb16">
                <div class="d-flex align-items-end ">
                    <div class="equal-width">
                        <div class="lh20 mb8 fsp14 neue-roman">
                            <label>{{ $t('views.P2P.New.44') }}</label>
                            <span class="require"> *</span>
                        </div>
                        <div class="d-flex flex-row align-items-center">
                            <InputSimple
                                placeholder="0"
                                :id="content.proffer.internal_direction == 'Maker2taker' ? 'rate_internal_count' : 'rate_external_count'" 
                                :dataValue="content.proffer.internal_direction == 'Maker2taker' ? data.rate_internal_count : data.rate_external_count" 
                                :invalid="content.proffer.internal_direction == 'Maker2taker' ? data.rate_internal_count === '' : data.rate_external_count === ''"
                                :invalidHint="$t('components.service.GetInputs.5')"
                                @updateParentState="this.setValue"
                                :regCheck='{f: (arg) => {
                                    return $lib.checkPrecision(arg, content.proffer.internal_direction == "Maker2taker" ? internal_precision : external_precision);
                                }}'
                            >
                                <span v-if="this.external_name || this.internal_name" class="primary-grey neue fsp14 d-inline-block text-nowrap text-end">
                                    {{ content.proffer.internal_direction == 'Maker2taker' ? internal_name : external_name }}
                                </span>
                            </InputSimple>
                        </div>
                    </div>
                    <div class="lh40 neue-roman" :class="{ 'mx4': isMobile, 'mx16': !isMobile }">
                        =
                    </div>
                    <div class="equal-width">
                        <div class="lh20 mb8 fsp14 neue-roman">
                            <label>{{ $t('views.P2P.New.45') }}</label>
                            <span class="require"> *</span>
                        </div>
                        <div class="d-flex flex-row align-items-center">
                            <InputSimple
                                placeholder="0"
                                :id="content.proffer.internal_direction == 'Maker2taker' ? 'rate_external_count' : 'rate_internal_count'" 
                                :dataValue="content.proffer.internal_direction == 'Maker2taker' ? data.rate_external_count : data.rate_internal_count" 
                                :invalid="content.proffer.internal_direction == 'Maker2taker' ? data.rate_external_count === '' : data.rate_internal_count === ''"
                                :invalidHint="$t('components.service.GetInputs.5')"
                                @updateParentState="this.setValue"
                                :regCheck='{f: (arg) => {
                                    return $lib.checkPrecision(arg, content.proffer.internal_direction == "Maker2taker" ? external_precision : internal_precision);
                                }}'
                            >
                                <span v-if="external_name || internal_name" class="primary-grey neue fsp14 d-inline-block text-nowrap text-end">
                                    {{ content.proffer.internal_direction == 'Maker2taker' ? external_name : internal_name }}
                                </span>
                            </InputSimple>
                        </div>
                    </div>
                </div>
            </div>
            <div class="border-b mb24 pb24">
                <div class="d-flex align-items-end gap-3 w-100" :class="{ 'flex-column': isMobile }">
                    <div class="equal-width" :class="{ 'w-100': isMobile }">
                        <div class="d-flex align-items-center mb8 fsp14 neue-roman">
                            <div class="lh20">
                                <label>{{ $t('views.P2P.New.17') }}</label>
                                <span class='require'> *</span>
                            </div>
                            <Popper :hover="true">
                                <Icon name="info" size="c16" class="ml4" />
                                <template #content>
                                    <label class="neue-roman fsp14 text-white">{{ $t('views.P2P.New.71') }}</label>
                                </template>
                            </Popper>
                        </div>
                        <InputSimple 
                            id="internal_min"
                            :class="this.checkedMinMaxValue ? 'limits-not-valid' : ''"
                            :dataValue="this.data.internal_min"
                            :placeholder="'0'"
                            :invalid="this.checkedMinMaxValue || this.data.internal_min === ''"
                            :invalidHint="data.internal_min === '' ? $t('components.service.GetInputs.5') : $t('views.P2P.New.41')"
                            @updateParentState="this.setValue"
                            :regCheck='{f: (arg) => {
                                return $lib.checkPrecision(arg, internal_precision);
                            }}'
                        />
                    </div>
                    <div class="equal-width" :class="{ 'w-100': isMobile }">
                        <div class="d-flex align-items-center fsp14 neue-roman mb8">
                            <div class="lh20">
                                <label class="">{{ $t('views.P2P.New.18') }}</label>
                                <span class='require'> *</span>
                            </div>
                            <Popper :hover="true">
                                <Icon name="info" size="c16" class="ml4" />
                                <template #content>
                                    <label class="neue-roman fsp14 text-white">{{ $t('views.P2P.New.72') }}</label>
                                </template>
                            </Popper>
                        </div>
                        <InputSimple 
                            id="internal_max"
                            :class="this.checkedMinMaxValue ? 'limits-not-valid' : ''"
                            :dataValue="this.data.internal_max"
                            :placeholder="'0'"
                            :invalid="this.checkedMinMaxValue || this.data.internal_max === ''"
                            :invalidHint="data.internal_max === '' ? $t('components.service.GetInputs.5') : $t('views.P2P.New.41')"
                            @updateParentState="this.setValue"
                            :regCheck='{f: (arg) => {
                                return $lib.checkPrecision(arg, internal_precision);
                            }}'
                        />
                    </div>
                </div>
                <div class="mt16">
                    <div class="d-flex align-items-center mb8 fsp14 neue-roman">
                        <div class="lh20">
                            <label>{{ $t('views.P2P.New.20') }}</label>
                            <span class="require"> *</span>
                        </div>
                        <Popper :hover="true">
                            <Icon name="info" size="c16" class="ml4" />
                            <template #content>
                                <label class="neue-roman fsp14 text-white">{{ $t('views.P2P.New.61') }}</label>
                            </template>
                        </Popper>
                    </div>
                    <InputSimple 
                        :dataValue='this.data.timeout'
                        :label="$t('views.P2P.New.20')"
                        id='timeout'
                        :placeholder="'0'"
                        :invalid="!timeCorrect || data.timeout === ''"
                        :invalidHint="data.timeout === '' ? $t('components.service.GetInputs.5') : $t('views.P2P.New.64')"
                        @updateParentState="this.setValue"
                        :require="true"
                        :regCheck='{f: (arg) => {
                            return this.checkTimeout(arg);
                        }}'
                    />
                </div>
            </div>
            <div class="d-flex flex-column gap-3">
                <div class="d-flex align-items-center justify-content-between">
                    <label class="fsp14 neue-roman">{{ $t('views.P2P.New.21') }}</label>
                    <SwitchSimple 
                        class='pl-4 pt-0' 
                        :dataValue="this.data.active" 
                        id='active' 
                        @updateParentState="this.setValue"
                    />
                </div>
                <div class="d-flex align-items-center justify-content-between">
                    <label class="fsp14 neue-roman">{{ $t('views.P2P.New.22') }}</label>
                    <SwitchSimple 
                        class='pl-4 pt-0' 
                        :dataValue="this.data.only_by_link" 
                        id='only_by_link' 
                        @updateParentState="this.setValue"
                    />
                </div>
                <div class="d-flex align-items-center justify-content-between">
                    <label class="fsp14 neue-roman">{{ $t('views.P2P.New.23') }}</label>
                    <SwitchSimple 
                        class='pl-4 pt-0' 
                        :dataValue="this.data.only_for_verified" 
                        id='only_for_verified' 
                        @updateParentState="this.setValue"
                    />
                </div>
            </div>
            <div class="d-flex mt24 gap-3" :class="{ 'mobile-modal-buttons': isMobile }">
                <Button
                    :name="$t('views.P2P.Edit.12')"
                    class="equal-width h48"
                    type='btn-warning'
                    @click="this.editProffer"
                    :disabled="this.disabledSave"
                    :loader="this.saveLoading"
                />
                <Button
                    :name="$t('views.P2P.New.24')"
                    class="equal-width h48"
                    type='btn-outline-grey'
                    @click="this.close"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/service/Button'; 
import Input from '@/components/service/Input';
import InputSimple from '@/components/service/InputSimple';
import SwitchSimple from '@/components/service/SwitchSimple';
import Popper from '@/components/service/Popper';
import Icon from '@/components/icons/Icon';

export default {
    components: {
        Button,
        Input,
        InputSimple,
        SwitchSimple,
        Popper,
        Icon,
    },
    props: {
        close: [Function],
    }, 
    data () {
        return { 
            content: this.$store.state.modal.content,
            saveLoading: false,
            data: {
                active: this.$store.state.modal.content.proffer.active,
                code: this.$store.state.modal.content.proffer.code,
                internal_direction: this.$store.state.modal.content.proffer.code,
                external_note: this.$store.state.modal.content.proffer.external_note,
                external_requisites: this.$store.state.modal.content.proffer.external_requisites,
                external_type: this.$store.state.modal.content.proffer.external_type,
                external_type_text: this.$store.state.modal.content.proffer.external_type_text,
                internal_max: this.$store.state.modal.content.proffer.internal_max,
                internal_min: this.$store.state.modal.content.proffer.internal_min,
                internal_curr: this.$store.state.modal.content.proffer.internal_curr,
                only_by_link: this.$store.state.modal.content.proffer.only_by_link,
                only_for_verified: this.$store.state.modal.content.proffer.only_for_verified,
                rate_external_count: this.$lib.precRound(this, this.$store.state.modal.content.proffer.rate_external_count, this.$store.state.modal.content.proffer.external_type_unit_precision),
                rate_internal_count: this.$store.state.modal.content.proffer.rate_internal_count,
                timeout: this.$store.state.modal.content.proffer.timeout,
            },
            checkedMinMaxValue: false,
            disabledSave: true,
            external_name: false,
            internal_name: false,
            timeCorrect: true,
            external_precision: null,
            internal_precision: null,
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        }
    },
    created () {
        this.getCurrList();
    },
    mounted() {
        console.log('mounted', this.content);

        this.disabledSave = !this.checkRequiredFields();
    },
    methods: {
        truncateString(str, maxLength) {
            if(!str) {
                return '';
            }
            return str.length > maxLength ? str.slice(0, maxLength) + '...' : str;
        },
        checkTimeout(arg) {
            let regExp = new RegExp(/[^0-9.]/g);
            let t = arg.replace(regExp, "");

            this.timeCorrect = t > 0 && t <= 2147483;
            console.log('checkTimeout', this.timeCorrect);
            return String(t);
        },
        getCurrList() {
            // DELTA: disabled
            // this.axios.post('GetlistExterlanTypes', {data: {}}).then(res => {
            //     if (res.data.body) {
            //         const externalList = res.data.body.external_types.tables[0].colvalues;
            //         const currsList = res.data.body.curr_lists;
            //
            //         // получить имя внутреннего актива
            //         const external = externalList.find(item => item.code == this.data.external_type);
            //         this.external_name = external.curr_text ? external.curr_text : external.unit_abbreviation;
            //         this.external_precision = external.unit_precision || '2';
            //
            //         // получить имя внешнего актива
            //         const internal = currsList.find(item => item.code == this.data.internal_curr);
            //         this.internal_name = internal.small_name;
            //         this.internal_precision = internal.precision || '2';
            //     }
            // })
        },
        setValue(arg) {
            this.data[arg.id] = arg.value;

            // лимит введен
            if (arg.id == 'internal_min' || arg.id == 'internal_max') {
                this.checkedMinMaxValue = this.isMinLargeMax();
            }
            this.disabledSave = !this.checkRequiredFields();
        },
        checkRequiredFields() {
            if (this.data.rate_external_count != '' &&
                this.data.rate_internal_count != '' &&
                this.data.internal_min != '' &&
                this.data.internal_max != '' &&
                this.data.timeout != ''
            ) {
                return true;
            }

            return false;
        },
        booleanToString(arg) {
            if (typeof arg == 'boolean') {
                return arg ? '1' : '0';
            } 

            return arg;
        },
        editProffer() {
            if (this.saveLoading) return;
            delete this.data.internal_direction;
            delete this.data.external_type_text;
            delete this.data.external_type;
            delete this.data.internal_curr;

            this.data.active = this.booleanToString(this.data.active);
            this.data.only_by_link = this.booleanToString(this.data.only_by_link);
            this.data.only_for_verified = this.booleanToString(this.data.only_for_verified);
            
            this.saveLoading = true;
            this.axios.post('SetparamsP2PProffer', {loader: 'none', data: this.data}).then(res => {
                this.content.updateData();
            }).finally(() => {
                this.saveLoading = false;
            });
        },
        isMinLargeMax() {
            if (this.data.internal_min != '' && this.data.internal_max != '') {
                // приводим строки к числам, не можем использовать Number т.к. Number - это компонент
                return Number(this.data.internal_min) > Number(this.data.internal_max);
            }

            return false;
        },
    }
}
</script>

<style lang="scss" scoped>
.curr-wrapper-element .curr-element {
    top: 6px;
    right: 10px;
    color: #A6A6A6;
    max-width: 120px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    @media (max-width: 768px) {
        max-width: 40px;
    }
}

.not-validate {
    border: 1px solid #FF7F11;
    border-radius: 0.375rem;
}

.not-validate:focus {
    border: 1px solid #FF7F11;
    border-radius: 0.375rem;
}
.h32 {
    height: 32px;
}
</style>
